import { useFormatValue } from '../../hooks/useFormatValue'
import { CardText } from '../subComponents/cardText'

interface IFlightDateProps {
    date: string
}
export const FlightDate = ({ date }: IFlightDateProps) => {
    const { formatValue } = useFormatValue()
    return <CardText variant="bodyBold">{formatValue(date, 'date')}</CardText>
}
